// extracted by mini-css-extract-plugin
export default {"Container":"Card_Container__TDBFP","Box":"Card_Box__TW0K3","Button":"Card_Button__Ls5u4"};